<template>
  <div class="section-about">
    <div data-aos="fade-up" :style="{width: '100%'}">
      <h2 class="heading-secondary">
        FRONT END FOCUSED
        <br />WITH FULL STACK EXPERIENCE
      </h2>
      <div class="tools">
        <div data-aos="fade-right">
          <div class="descriptions">
            <div class="desc-top">
              <span>MOTIVATED TO PRODUCE RESULTS</span>
              <p>As a tenacious self-taught programmer, I use continuous iteration to produce results quickly and continuously improve products.</p>
            </div>
            <div class="desc-bot">
              <span>AN AGILE COLLABORATOR</span>
              <p>I have contributed to open source projects, worked on engineering teams, and always stay attuned to the newest frameworks.</p>
            </div>
          </div>
        </div>
        <div data-aos="fade-left" :style="{width: '100%'}">
          <div class="icons" >
            <i class="devicon-javascript-plain colored"></i>
            <i class="devicon-react-original colored"></i>
            <i class="devicon-vuejs-plain colored"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>